import { Stack, styled } from '@mui/material';

export const Row = styled(Stack)({
  alignItems: 'center',
  flexDirection: 'row',
}) as typeof Stack;
